<template>
  <div class="teamBox flex">
    <ul class="leftBox">
      <li class="active">Goals Conceded</li>
      <li>Goals Conceded</li>
      <li>Goals Conceded</li>
      <li>Goals Conceded</li>
      <li>Goals Conceded</li>
    </ul>
    <div class="rightBox flex-1">
      <table>
        <thead>
          <tr>
            <th width="30">#</th>
            <th width="318">Teams</th>
            <th width="100">Average</th>
            <th width="100">Total</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in list">
            <tr :key="index">
              <td v-if="index < 3" :style="index < 3 ? {lineHeight: 0} : {}"><img :src="require('@/assets/images/cup_'+ (Number(index)+1) + '.svg')"></td>
              <td v-if="index > 2">4</td>
              <td>
                <div class="flex flex-align-center">
                  <img class="teamImg" :src="require('@/assets/images/home.png')">
                  <div>111</div>
                </div>
              </td>
              <td>1</td>
              <td>1</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[
        {id: 1,order: 1,teamName: 'Manchester City',teamImg: '',Average: '1',Total: 1},
        {id: 2,order: 2,teamName: 'Manchester City',teamImg: '',Average: '1',Total: 1},
        {id: 3,order: 3,teamName: 'Manchester City',teamImg: '',Average: '1',Total: 1},
        {id: 4,order: 4,teamName: 'Manchester City',teamImg: '',Average: '1',Total: 1},
      ]
    }
  }
}
</script>

<style lang="less">
.teamBox {
  background: @color_FFF;
  padding: 16px 8px 48px 8px;
  .leftBox{
    background: @color_F0F0F0;
    width: 180px;
    padding: 8px;
    margin-right: 16px;
    li{
      color: @color_434343;
      font-family: @font_family_SF_Pro_Display;
      line-height: 32px;
      font-size: 14px;
      padding-left: 8px;
      cursor: pointer;
    }
    li.active{
      border-radius: 4px;
      background: @color_FFF;
      font-weight: bold;
      color: @color_FF6915;
    }
    li:hover{
      border-radius: 4px;
      background: @color_FFF;
    }
  }
  .rightBox{
    table{
      width: 100%;
      font-family: @font_family_SF_Pro_Display;
      line-height: 24px;
      color: @color_434343;
      text-align: center;
      thead {
        background: @color_F5F5F5;
        th {
          padding: 8px;
          text-align: center;
          &:nth-child(2) {
            text-align: left;
          }
        }
      }
      tbody {
        tr {
          border-bottom: 1px solid @color_F0F0F0;
          td {
            padding: 16px 8px;
            &:nth-child(2) {
              text-align: left;
            }
            .teamImg{
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/components/teamsTable.vue